export enum SignaturePageNumberLocationType {
  FromStart = 0,
  FromEnd = 1
}